import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { castTo } from '../../shared/utils/cast-to';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { AppDto } from '../dtos/app.dto';
import { AppRequestModel } from '../models/app-request.model';
import { AppModel } from '../models/app.model';
import { mapAppRequestModelToAppRequestDto } from '../utils/app-mapping.utils';
import { mapAppDtoToAppModel } from '../utils/mapping.utils';

export const updateApp: AsyncThunk<
  AppModel,
  AppRequestModel,
  Record<string, unknown>
> = createAsyncThunk('app/update-app', async (data: AppRequestModel) => {
  const dataDto = mapAppRequestModelToAppRequestDto(data);
  const url = createPathParams<'appId'>(Endpoints.APP_BY_ID, {
    appId: castTo<string>(data.id),
  });
  const resp: AxiosResponse<AppDto> = await axiosInstance.put(url, dataDto);

  return mapAppDtoToAppModel(resp.data);
});
